<script>
    export default {
        name: "UrlGenerator",
        data() {
            return {
                prefixAttribute: '/products/attribute/',
                prefixRegion: '/regions/'
            }
        },
        methods: {
            urlAttributeProducts(attribute, value) {
                // attribute = attribute.replace(/[A-Z]/g, m => "-" + m.toLowerCase());

                if(!attribute || !value)
                    return '';

                return this.prefixAttribute + attribute + '/' + value;
            },
            urlRegionProducts(region) {
                return this.prefixRegion + region;
            }
        }
    }
</script>
